export const checkForUser = (arrayOfCriteria, usersIdForThatCriteria) => {
  if (
    !arrayOfCriteria.length ||
    arrayOfCriteria.includes(usersIdForThatCriteria)
  ) {
    return true;
  }
  return false;
};
